module.exports = __webpack_public_path__ + "static/media/pic-laufrouten-1.dc28cec7.jpg";